
import { defineComponent, ref, computed } from '@vue/composition-api'

import { translationsApi } from '@/api'
import { useNotify } from '@/store'
import { ValidationForm, required } from '@/utils/validation'

import CommonFlagIcon from '@/components/common/common-flag-icon.vue'
import { resolveCountry } from '@/plugins/i18n'
import { mdiEarth } from '@mdi/js'

export default defineComponent({
  name: 'admin-add-translation',
  components: {
    CommonFlagIcon,
  },
  setup(props, { root, emit }) {
    const { updateTranslation, isLoading } = translationsApi.useUpdateTranslation()

    const { addNotification } = useNotify()

    const addTranslationForm = ref<ValidationForm | null>(null)

    const implementedLocales = computed<string[]>(() => root.$store.state.locale.implementedLocales)

    const keyInput = ref('')

    const translationInputs = ref<{ [key: string]: string }>({})

    const addTranslation = () => {
      if (addTranslationForm.value?.validate()) {
        const promises = Object.entries(translationInputs.value).map(([locale, value]) =>
          updateTranslation({ key: keyInput.value, value, locale })
        )

        Promise.all(promises)
          .then(() => {
            addNotification({
              type: 'success',
              text: root.$t('translations.add.success', {
                key: keyInput.value,
              }) as string,
            })

            emit('translation-added')
            emit('close')
          })
          .catch((error) => {
            error.userMessage = root.$t('translations.add.error', {
              key: keyInput.value,
            }) as string

            throw error
          })
      }
    }

    return {
      icons: { mdiEarth },
      addTranslationForm,
      required,
      isLoading,
      keyInput,
      translationInputs,
      addTranslation,
      resolveCountry,
      implementedLocales,
    }
  },
})
